import { Email, EmailThreadSortOrder } from "@/components/molecules/email";
import { Message } from "@/repository/models/message";
import { useMemo } from "react";

export { useScrollEmailConversationToBottom } from "./useScrollEmailConversationToBottom";

export const useEmailLoadingMethods = (
	sessionId: string,
	isHistory: boolean = false,
	messages: Message[] | undefined,
	allMessagesOpen: boolean = false,
	emailHeaderActions?: (
		message: Message,
		isLastMessage: boolean
	) => JSX.Element,
	emailFooterActions?: (
		message: Message,
		isLastMessage: boolean
	) => JSX.Element,
	isPreview: boolean = false,
	highlightedMessageId?: string,
	sortOrder: EmailThreadSortOrder = "oldest-first"
) => {
	const emails = useMemo<JSX.Element[]>(() => {
		const sorted = messages
			?.filter((x: Message) => !x.isDraft)
			.sort((x: Message, y: Message) => {
				const diff = Date.parse(x.receivedDateTime) - Date.parse(y.receivedDateTime);
				return sortOrder === "newest-first" ? -diff : diff;
			}) ?? [];

		return sorted.map((x: Message, index: number) => {
			const isNewestMessage = sortOrder === "newest-first"
				? index === 0
				: index === sorted.length - 1;

			return (
				<Email
					key={x.id}
					email={{ ...x, sessionId: sessionId }}
					index={index}
					isHistory={isHistory}
					isDefaultOpen={allMessagesOpen || isNewestMessage}
					isHighlighted={
						!!highlightedMessageId && x.id === highlightedMessageId
					}
					headerActions={
						!isPreview && emailHeaderActions
							? emailHeaderActions(x, isNewestMessage)
							: undefined
					}
					footerActions={
						!isPreview && emailFooterActions
							? emailFooterActions(x, isNewestMessage)
							: undefined
					}
					isPreview={isPreview}
				/>
			);
		});
	}, [messages, emailHeaderActions, emailFooterActions, highlightedMessageId, sortOrder]);

	return { emails };
};
